import {
  EXCEPTION_RULES_LIST,
  EXCEPTION_RULES_LIST_LOADING,
  EXCEPTION_ALERT_INSTANCES_LOADING,
  SET_EXCEPTION_ALERT_INSTANCES,
} from 'src/actions/constants';

export default function (state: any = { isListLoading: true }, action) {
  switch (action.type) {
    case EXCEPTION_RULES_LIST:
      return {
        ...state,
        isListLoading : false,
        exceptionRuleListData : action.data,
      };
    case EXCEPTION_RULES_LIST_LOADING:
      return {
        ...state,
        isListLoading: true,
      };
    case EXCEPTION_ALERT_INSTANCES_LOADING:
      return {
        ...state,
        isExceptionAlertInstanceLoading: true,
      };
    case SET_EXCEPTION_ALERT_INSTANCES:
      return {
        ...state,
        exceptionAlertInstances: action.data,
        isExceptionAlertInstanceLoading: false,
      };

    default:
      return state;
  }
}
